import { render, staticRenderFns } from "./goodsClassOffline.vue?vue&type=template&id=4108f467&"
import script from "./goodsClassOffline.vue?vue&type=script&lang=js&"
export * from "./goodsClassOffline.vue?vue&type=script&lang=js&"
import style0 from "./goodsClassOffline.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports